import { type FunctionalComponent, h } from '@stencil/core'
import { ItemsPanel, type ItemsPanelProps } from './ItemsPanel'

export const ItemsPanelOuter: FunctionalComponent<ItemsPanelProps> = ({
  itemsData,
  selectedItem,
  onSelectItem,
  onRefreshItems,
  isLoadingAccount,
  isLoadingItems,
  itemsError,
  statusMessage
}) => (
  <div class="debug-toolbar-panel open">
    <div class="debug-toolbar-header">
      <h3>Items Selection</h3>
    </div>
    <div class="debug-toolbar-section">
      <ItemsPanel
        itemsData={itemsData}
        selectedItem={selectedItem}
        onSelectItem={onSelectItem}
        onRefreshItems={onRefreshItems}
        isLoadingAccount={isLoadingAccount}
        isLoadingItems={isLoadingItems}
        itemsError={itemsError}
        statusMessage={statusMessage}
      />
    </div>
  </div>
)
